import { useConversationsStore } from '@/stores/conversations/conversations.store';
import { ConversationType } from '@/types/conversation.types';
import type { UnreadMessagesUpdateType } from '@/types/events/unread-messages-update';

export default function unreadMessagesUpdate(data: UnreadMessagesUpdateType): void {
  const conversationsStore = useConversationsStore();
  conversationsStore.updateOrInsertConversation(data.conversationData);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
  }
}
